import React, { useState, useEffect } from 'react';

interface Props {
  text: string;
}

const TYPING_SPEED_MS = 50;
const PAUSE_BEFORE_RESTART_MS = 2000;
const PREFIX_ICON = '✦ ';

const OptimisticMessage = ({ text }: Props) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const fullText = PREFIX_ICON + text;

  useEffect(() => {
    if (currentIndex >= fullText.length) {
      const restartTimer = setTimeout(() => {
        setDisplayedText('');
        setCurrentIndex(0);
      }, PAUSE_BEFORE_RESTART_MS);
      return () => clearTimeout(restartTimer);
    }
    const timer = setTimeout(() => {
      setDisplayedText(prev => prev + fullText[currentIndex]);
      setCurrentIndex(prev => prev + 1);
    }, TYPING_SPEED_MS);
    return () => clearTimeout(timer);
  }, [currentIndex, fullText]);

  return (
    <div style={styles.container}>
      <span style={styles.hiddenText}>{fullText}</span>
      <span style={styles.visibleTextWrapper}>
        <span style={styles.text}>{displayedText}</span>
        <span style={styles.cursor}>|</span>
      </span>
    </div>
  );
};

const styles = {
  container: {
    padding: '12px 16px',
    borderRadius: '8px',
    backgroundColor: '#f5f5f5',
    display: 'inline-block' as const,
    position: 'relative' as const
  },
  hiddenText: {
    visibility: 'hidden' as const,
    whiteSpace: 'pre' as const
  },
  visibleTextWrapper: {
    position: 'absolute' as const,
    top: '12px',
    left: '16px'
  },
  text: {
    color: '#666666'
  },
  cursor: {
    color: '#666666',
    animation: 'blink 1s infinite',
    marginLeft: '2px'
  }
};

const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes blink {
    0%, 50% { opacity: 1; }
    51%, 100% { opacity: 0; }
  }
`;
document.head.appendChild(styleSheet);

export default OptimisticMessage;
